import {
  Component,
  OnInit,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  AfterViewChecked,
  Input,
  SimpleChanges,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { CustomvalidationService } from 'src/app/middleware/common/resuableServices/validatorServices';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { AddOrganizationReqVM } from 'src/app/viewModels/organization/add-organization-req-vm';
import * as jwt_decode from 'jwt-decode';
import { OrganizationService } from '../services/organization/organization.service';

@Component({
  selector: 'app-add-organizations',
  templateUrl: './add-organizations.component.html',
  styleUrls: ['./add-organizations.component.scss'],
})
export class AddOrganizationsComponent implements OnInit, AfterViewChecked {
  @ViewChild('organizatioName', { static: true }) organizatioName: ElementRef;
  @ViewChild('searchCountry') searchCountryclear: ElementRef;
  @ViewChild('searchState') searchStateClear: ElementRef;
  @ViewChild('searchCity') searchCityClear: ElementRef;

  databaseName:string="";
  databaseNameShow:boolean=false;

  constructor(
    private formBuilder: FormBuilder,
    private customValidator: CustomvalidationService,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,
    private statusConst: StatusConstant,
    private loaderService: LoaderService,
    private toastr: ToastrService,
    private router: Router,
    private addOrgVm: AddOrganizationReqVM,
    private organizationService: OrganizationService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
  }

  
  ngOnInit(): void {   
    this.organizatioName.nativeElement.focus();
    const emailregex: RegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;

    this.addOrganizationForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern(emailregex)]],
      organizatioName: ['', Validators.required],
      databaseName: ['', Validators.required],
      address1: ['', Validators.required],
      address2: [''],
      cityId: ['', Validators.required],
      stateId: ['', Validators.required],
      countryId: ['', Validators.required],
      zipCode: ['', Validators.required],
      password: ['',[Validators.required, this.customValidator.checkPassword.bind(this.customValidator),],],
      phoneNumber: ['', [Validators.required, Validators.pattern(phoneNumberregex)],],
      organationType: ['', Validators.required],
      isActive: true,
    });

    this.organizationTypeList = [
      { id: 1, name: 'Shared' },
      { id: 2, name: 'Dedicated' },
    ];

    this.getCountryListDropdown();
  }
  
  onChangeCountry(message){
    const searchInput=message ? message.toLowerCase() : '';
    this.countryList=this._countryList.filter(u=>{
      const name:string=u.countryName.toLowerCase();
      return name.indexOf(searchInput)>-1;
    });
  }

  onChangeState(message){
    const searchInput=message ? message.toLowerCase() : '';
    this.stateList=this._stateList.filter(u=>{
      const name:string=u.stateName.toLowerCase();
      return name.indexOf(searchInput)>-1;
    });
  }
  
  onChangeCity(message){
    const searchInput=message ? message.toLowerCase() : '';
    this.cityList=this._cityList.filter(u=>{
      const name:string=u.cityName.toLowerCase();
      return name.indexOf(searchInput)>-1;
    });
  }

  ngAfterViewChecked() {
    // setTimeout(() => {
    //   this.organizatioName.nativeElement.focus();
    // }, 1);
  }

  checkDbName(event) {
    if(event.code=="Space"){
      event.preventDefault();
		  return false;
    }
		const regexp = new RegExp('^[!@#$&%^*()\\-`.+,/\"]*$');
		const result = regexp.test(event.key);
		if (result) {     
		  event.preventDefault();
		  return false;
		}else{
     
    }
  }
  
  
  addOrganizationForm: FormGroup;
  hide = true;
  isActiveChecked:boolean=true;
  organizationTypeList: any[] = [];
  addOrgResponseHolder: any;
  coutryListResponseHolder: any;
  countryList: any[] = [];
  countrySelected: any;
  stateListRResponseHolder: any;
  stateList: any[] = [];
  _stateList: any[] = [];
  stateSelected: any;
  cityListRResponseHolder: any;
  cityList: any[] = [];
  _cityList: any[] = [];
  citySelected: any;
  zipCode: any;
  showErrorMessage: boolean = false;
  currentUser: any;
  _countryList:any[]=[];
  @Output() closeSidePanel = new EventEmitter();


  getErrorEmail() {
    return this.customValidator.getErrorEmail(this.addOrganizationForm);
  }

  // Get Errors for password field
  getErrorPassword() {
    return this.customValidator.getErrorPassword(this.addOrganizationForm);
  }

  // Get Errors for phoneNumber field
  getPhoneErrorMessage() {
    return this.customValidator.getPhoneErrorMessage(this.addOrganizationForm);
  }

  close() {  
    let closePanel = false;
    this.addOrganizationForm.reset();
    this.stateList=undefined;
    this.cityList=undefined;
    this.searchCountryclear.nativeElement.value='';
    this.searchStateClear.nativeElement.value='';
    this.searchCityClear.nativeElement.value='';
    this.onChangeCountry("");
    this.isActiveChecked=true;
    this.addOrganizationForm.controls.isActive.setValue(true);
    this.closeSidePanel.emit(closePanel);
  }

  CheckStatus(event){
    if(event.checked==true){
      this.isActiveChecked=true;
    }else{
      this.isActiveChecked=false;
    }
  }
  
  SelectionOrganationType(event:any) {
    //1-Shared, 2-Dedicated
    if(event.value==2){
    this.databaseNameShow=true;
    this.addOrganizationForm.controls.databaseName.setValue(null);   
    }else{
      this.databaseNameShow=false;
      this.addOrganizationForm.patchValue({
        databaseName: " "
     });     
    }
  }

  addOrganization(formValues) {
    if (formValues != undefined) {
      this.addOrgVm.organizationID = 0;
      this.addOrgVm.email = formValues.email.toLowerCase();
      this.addOrgVm.isActive = this.isActiveChecked;//formValues.isActive;
      this.addOrgVm.organizationName = formValues.organizatioName;
      this.addOrgVm.databaseName = formValues.databaseName.trim();
      this.addOrgVm.organizationType = formValues.organationType;
      this.addOrgVm.password = formValues.password;
      this.addOrgVm.phoneNumber = formValues.phoneNumber;
      this.addOrgVm.stateID = parseInt(formValues.stateId);
      this.addOrgVm.zipCode = formValues.zipCode;
      this.addOrgVm.cityID = parseInt(formValues.cityId);
      this.addOrgVm.countryID = parseInt(formValues.countryId);
      this.addOrgVm.address1 = formValues.address1;
      this.addOrgVm.address2 = formValues.address2;
      this.addOrgVm.createdBy = this.currentUser.UID;
      this.loaderService.show();
     // return;
      this.organizationService.addOrganization(this.addOrgVm).subscribe((response) => {
          if (response != undefined) {
            this.addOrgResponseHolder = response;
            if(this.addOrgResponseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.toastr.success('Organization added successfully.', '', {
                timeOut: 3000,
              });
              let closePanel = true;              
              this.closeSidePanel.emit(closePanel);
              this.addOrganizationForm.reset();
              this.stateList=undefined;
              this.cityList=undefined;
              this.searchCountryclear.nativeElement.value='';
              this.searchStateClear.nativeElement.value='';
              this.searchCityClear.nativeElement.value='';
              this.onChangeCountry("");
              this.isActiveChecked=true;
              this.addOrganizationForm.controls.isActive.setValue(true);  
            } else {
              this.loaderService.hide();
              this.toastr.error(this.addOrgResponseHolder.message, '', {
                timeOut: 3000,
              });             
              let closePanel = true;
              this.closeSidePanel.emit(closePanel);
              this.isActiveChecked=true;
              this.addOrganizationForm.controls.isActive.setValue(true);
            }
          }else{
            this.loaderService.hide();
          }
        });
    }
  }

  getCountryListDropdown() {
    this.organizationService.getCountryList().subscribe((response) => {
      if (response) {
        this.coutryListResponseHolder = response;
        if(this.coutryListResponseHolder.status == this.statusConst.statusSuccess) {          
          this.countryList = this.coutryListResponseHolder.data;
          this._countryList=this.coutryListResponseHolder.data;
          var USACountry=[];
          USACountry = this.coutryListResponseHolder.data.filter(x => x.countryName =="United States");
          if(USACountry.length >0){
            this.countrySelected=USACountry[0].countryID;
            this.getStateDropdownListUSA( this.countrySelected);
          }
         // this.countrySelected=this.coutryListResponseHolder.data.filter(x => x.countryName =="United States");
        }
      }
    });
  }

  getStateDropdownList(event) {
    if (event.value != undefined) {
      this.organizationService.getStateList(this.countrySelected).subscribe((response) => {
          if (response) {
            this.stateListRResponseHolder = response;
            if(this.stateListRResponseHolder.status == this.statusConst.statusSuccess) {
              if(this.countrySelected == 231 || this.countrySelected == 38){              
                this.stateListRResponseHolder.data  =  this.stateListRResponseHolder.data.filter((x) => x.abbreviation != null);
                this.stateList = this.stateListRResponseHolder.data;
                this._stateList=this.stateListRResponseHolder.data;
              }else{
                this.stateList = this.stateListRResponseHolder.data;
                this._stateList=this.stateListRResponseHolder.data;
              } 
             // this.stateList = this.stateListRResponseHolder.data;
             // this._stateList=this.stateListRResponseHolder.data;
            }
          }
        });
    }
  }

  getStateDropdownListUSA(countrySelected) {
    if (countrySelected != undefined) {
      this.organizationService.getStateList(countrySelected).subscribe((response) => {
          if (response) {
            this.stateListRResponseHolder = response;
            if(this.stateListRResponseHolder.status == this.statusConst.statusSuccess) {
              if(countrySelected == 231 || countrySelected == 38){              
                this.stateListRResponseHolder.data  =  this.stateListRResponseHolder.data.filter((x) => x.abbreviation != null);
                this.stateList = this.stateListRResponseHolder.data;
                this._stateList=this.stateListRResponseHolder.data;
              }else{
                this.stateList = this.stateListRResponseHolder.data;
                this._stateList=this.stateListRResponseHolder.data;
              } 
             // this.stateList = this.stateListRResponseHolder.data;
             // this._stateList=this.stateListRResponseHolder.data;
            }
          }
        });
    }
  }


  getCityDropdownList(event) {
    if (event.value != undefined) {
      this.organizationService.getCityList(this.stateSelected).subscribe((response) => {
          if (response) {
            this.cityListRResponseHolder = response;
            if(this.cityListRResponseHolder.status ==  this.statusConst.statusSuccess) {
              this.cityList = this.cityListRResponseHolder.data;
              this._cityList=this.cityListRResponseHolder.data;
            }
          }
        });
    }
  }

  //Summary
  //Check Validate token length and enable Confirm button
  checkValidatorLength() {
    if (this.zipCode.length < 3 || this.zipCode > 6) {
      this.showErrorMessage = true;
    } else {
      this.showErrorMessage = false;
    }
  }

 

}

